export default {"src":"/_next/static/media/bsc-color.fdb1a5ff.svg","height":2496,"width":2496,"blurWidth":0,"blurHeight":0};